module.exports = __webpack_public_path__ + "static/008.thumb-425197423dfb7ec8d088cd5f707f492c.jpg";